<template>
    <div>
        <slot v-if="firstMount" />

        <div v-else-if="shouldTruncate && !revealingAll">
            <div v-html="truncatedHTML"></div>
        </div>

        <div v-else v-html="givenHTML"></div>

        <div v-if="shouldTruncate" style="margin-top: 5px;">
            <span @click.prevent="toggleReveal">
                <slot name="read-more-button">
                    <button type="button" class="like-link">
                        <slot name="reveal-more-text" v-if="!revealingAll">
                            Read more
                        </slot>
                        <slot name="reveal-less-text" v-else>
                            Read less
                        </slot>
                    </button>
                </slot>
            </span>
        </div>

    </div>
</template>

<script>
import truncate from 'html-truncate';

export default {
    props: {
        length: [Number, String],
        threshold: { default: 0.05 }, // The content returned from `truncate` isn't always exactly what it's been given (e.g. self-closing tags).
        maximumAttributeKeyLength: { default: 12 } // Workaround for https://github.com/huang47/nodejs-html-truncate/issues/26
    },

    data() {
        return {
            firstMount: true,
            revealingAll: false,
            givenHTML: '',
            safeToTruncateHTML: ''
        };
    },

    computed: {
        shouldTruncate() {
            return this.givenHTML.length - this.truncatedHTML.length > this.threshold * this.givenHTML.length;
        },

        truncatedHTML() {
            return truncate(this.safeToTruncateHTML, parseFloat(this.length), { keepImageTag: true });
        }
    },

    mounted() {
        this.givenHTML = this.$el.innerHTML;

        const descendants = this.$el.querySelectorAll('*');
        Array.prototype.forEach.call(descendants, descendant => {
            Array.prototype.forEach.call(descendant.attributes, attribute => {
                if (attribute.name.length >= this.maximumAttributeKeyLength) {
                    descendant.removeAttribute(attribute.name);
                    console.warn('truncate: Removed long attribute', attribute.name, 'from', descendant);
                }
            });
        });

        this.safeToTruncateHTML = this.$el.innerHTML;

        this.firstMount = false;
    },

    methods: {
        toggleReveal() {
            this.revealingAll = !this.revealingAll;
        }
    }
};
</script>
